import type { BulkEditedUnit } from '../../../shared/domain/unitEvents/getBulkEditedUnits'
import type { UUID } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Request, RequestArgs, Route } from '../types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/units/getByBulkEditId' }

type Params = never
type Body = never
type Query = { bulkEditId: UUID }
// N.B. we don't use normal domain types (such as `unit`) here, because we are returning
// historical data, ie the name and image as they were at the time of the edit.
type Output = { units: BulkEditedUnit[] }

export type GetByBulkEditIdEndpoint = Endpoint<Params, Body, Query, Output>

export const getByBulkEditIdRequest = (request: Request, args: RequestArgs<GetByBulkEditIdEndpoint>) =>
    request<GetByBulkEditIdEndpoint>(route, args)
